import { render, staticRenderFns } from "./SmartMilling.vue?vue&type=template&id=67d5d4a6&scoped=true&"
import script from "./SmartMilling.vue?vue&type=script&lang=js&"
export * from "./SmartMilling.vue?vue&type=script&lang=js&"
import style0 from "./SmartMilling.vue?vue&type=style&index=0&id=67d5d4a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d5d4a6",
  null
  
)

export default component.exports